import axios from "axios";
import Links from "../constants/Links";

const Curriculum = {
    create: async (data) => {
        return axios.post(Links.curricula.create, data);
    },

    copy: async (sourceCurriculumId, data) => {
        return axios.post(Links.curricula.copy + sourceCurriculumId, data);
    },

    update: async (id, data) => {
        return axios.put(Links.curricula.update + id, data);
    },

    getById: async (id) => {
        return axios.get(Links.curricula.getById + id);
    },

    byProgramme: async (programmeId) => {
        return axios.get(Links.curricula.byProgramme + programmeId);
    },

    setDefault: async (id) => {
        return axios.post(Links.curricula.setDefault + id + "/set-default");
    },

    disable: async (id) => {
        return axios.delete(Links.curricula.disable + id);
    },

    createMapping: async (data) => {
        return axios.post(Links.curricula.mappings.create, data);
    },

    getMappingsByProgramme: async (programmeId) => {
        return axios.get(Links.curricula.mappings.byProgramme + programmeId);
    },

    activateMapping: async (mappingId) => {
        return axios.post(Links.curricula.mappings.activate + mappingId + "/activate");
    },

    deactivateMapping: async (mappingId) => {
        return axios.post(Links.curricula.mappings.deactivate + mappingId + "/deactivate");
    },

    deleteMapping: async (mappingId) => {
        return axios.delete(Links.curricula.mappings.delete + mappingId);
    },

    createOverride: async (data) => {
        return axios.post(Links.curricula.overrides.create, data);
    },

    removeOverride: async (studentId) => {
        return axios.delete(Links.curricula.overrides.remove + studentId);
    },

    resolve: async (studentId) => {
        return axios.get(Links.curricula.resolve + studentId);
    },

    getCourses: async (curriculumId) => {
        return axios.get(Links.curricula.courses.list + curriculumId + "/courses");
    },

    addCourse: async (curriculumId, data) => {
        return axios.post(Links.curricula.courses.add + curriculumId + "/courses", data);
    },

    bulkAddCourses: async (curriculumId, data) => {
        return axios.post(Links.curricula.courses.bulkAdd + curriculumId + "/courses/bulk", data);
    },

    updateCourse: async (curriculumId, programmeCourseId, data) => {
        return axios.put(Links.curricula.courses.update + curriculumId + "/courses/" + programmeCourseId, data);
    },

    removeCourse: async (curriculumId, programmeCourseId) => {
        return axios.delete(Links.curricula.courses.remove + curriculumId + "/courses/" + programmeCourseId);
    },

    assignCourse: async (curriculumId, programmeCourseId) => {
        return axios.post(Links.curricula.courses.assign + curriculumId + "/courses/" + programmeCourseId + "/assign");
    },

    getStudentCourses: async (studentId) => {
        return axios.get(Links.curricula.students.courses + studentId + "/courses");
    },
};

export default Curriculum;
